import Loader from 'react-loader-spinner'

export const Spinner = (): React.ReactElement => <Loader type="TailSpin" color="#00BFFF" height={100} width={100} />
